import { useContext } from 'react';
import CustomerSearchContext from './CustomerSearchContext';

const useCustomerSearchContext = () => {
  const context = useContext(CustomerSearchContext);
  if (!context) {
    throw new Error(
      'useCustomerSearchContext must be used within an CustomerSearchContext.Provider',
    );
  }
  return context;
};

export default useCustomerSearchContext;
